module.exports = __webpack_public_path__ + "assets/img/1.05cee6f2.jpg";